
import CloseIcon from '@mui/icons-material/Close';
import React, { useContext } from 'react'

import { useParams } from 'react-router'
import {useState,useEffect} from 'react'
import axios from 'axios'
import ENDPOINT from '../../context/EndPoint'

import { AuthContext } from '../../context/AuthContext'
import {  Toast } from 'react-bootstrap'
import { Avatar } from '@mui/material';
import { useDispatch } from 'react-redux';

const ScheduleInterview = ({account,item,timeline,intern_id}) => {
  
   const dispatch = useDispatch()   
const {user} = useContext(AuthContext)
     const params = useParams();
     const internship_id = params.internshipid;
   //  //  // console.log("internship id"+internship_id);



const [tasks,settasks] = useState(null)

const [status,setstatus] = useState("all");
const [description,setdescription] = useState(null)
const [startdate,setstartdate] = useState(null)
const [enddate,setenddate] = useState(null)
const [begins,setbegins] = useState(null);
const [ends,setends]= useState(null)
const [meetlink,setmeetlink] = useState(null)
const [meetdescription,setmeetdescription]= useState(null)
const [internships,setinternships] = useState(null)
const [meetingtype,setmeetingtype]= useState("General Meeting")
const [currentinternship,setcurrentinternship] = useState(null)
const scheduleMeeting = async () => {
     dispatch({ type: 'LOADING' });
   
     const formData = new FormData();
     formData.append('session', user.SessionId);
     formData.append('internship_id', currentinternship);
     if (intern_id) {
       formData.append('intern_id', intern_id);
     }
     formData.append('date', startdate);
     formData.append('begins', begins);
     formData.append('ends', ends);
     formData.append('meeting_type', meetingtype);
     formData.append('meeting_link', meetlink);
     formData.append('description', description);
   
     try {
       const res = await axios.post(
         ENDPOINT + "admin-schedule-interview.php",
         formData,
         {
           headers: {
             'content-type': 'multipart/form-data'
           }
         }
       );
   
       if (res?.data) {
         if (res.data.status === "success") {
           dispatch({ type: 'DONE_LOADING' });
           settoasttitle("Interview scheduled");
           settoast(true);
         } else {
           dispatch({ 
             type: 'ERROR', 
             payload: res.data.message || 'Failed to schedule meeting' 
           });
           settoasttitle("Something went wrong");
           settoast(true);
         }
       } else {
         dispatch({ 
           type: 'ERROR', 
           payload: 'Invalid response format' 
         });
         settoasttitle("Something went wrong");
         settoast(true);
       }
     } catch (error) {
       dispatch({ 
         type: 'ERROR', 
         payload: error.message || 'An error occurred while scheduling meeting' 
       });
       settoasttitle("Something went wrong");
       settoast(true);
     }
   };




          
const openSubmission = ()=>{
     setsubmit(true)
}

const [submit,setsubmit] = useState(false)
const [taskid,settaskid] = useState(null)

const [toast,settoast] = useState(false)


const [toastmessage,settoastmessage] = useState(null)
const [toasttitle,settoasttitle] = useState(null)












     





     return (
          <>
              <>
              

              <div className="position-fixed container-fluid left-0 bottom-60 justify-center">
<Toast className="bg-warning" show={toast} onClose={()=>{settoast(false)}} autohide={true} delay={5000}>
          <Toast.Header>
            <img
              src="holder.js/20x20?text=%20"
              className="rounded me-2"
              alt=""
            />
            <strong className="me-auto">{toasttitle}</strong>
            
          </Toast.Header>
          <Toast.Body>{toastmessage}</Toast.Body>
        </Toast>
</div>



           
<div>
<div className="d-flex">
     <Avatar src={item.profile_pic}/>
     <div className='ms-2'>
     <h5 className='m-0 p-0-'>{item.first_name+" "+item.last_name}</h5>
     <p className='m-0 p-0'>Internship  Id: {item.internship_id}</p>
     </div>
</div>
<hr></hr>
<div className="mt-4">
     <h6>Start Date</h6>
     <input  onChange={(e)=>setstartdate(e.target.value)}  className="form-control" type="date"></input>
</div>
<div className="flex mt-2 justify-content-between w-100">


<div className='col' >
     <h6>Start Time</h6>
     <input  onChange={(e)=>setbegins(e.target.value)}  className="form-control" type="time"></input>
</div>

<div className='col' >
     <h6>End Time</h6>
     <input  onChange={(e)=>setends(e.target.value)}  className="form-control" type="time"></input>
</div>
</div>

<div className="w-100 mt-3">
     <h6>Interview Type</h6>

     <select  onChange={(e)=>{setmeetingtype(e.target.value)}} className="form-control" >
     <option>Select Options</option>
<option value="telephonic">Telephonic Interview</option>
<option value="zoomcall">Zoom Call Interview</option>
<option  value="walkin">Walkin Interview</option>
     </select>

</div>

<input onChange={(e)=>setmeetdescription(e.target.value)} className="form-control mt-3" placeholder="description"></input>
<input  onChange={(e)=>setmeetlink(e.target.value)}  className="form-control mt-3" placeholder="Meeting Link"></input>
<button onClick={()=>scheduleMeeting()} className="btn btn-primary mt-5 w-100">Confirm Schedule</button>
<div>

</div>



</div>
    






              </>
       
          </>
     )
}

export default ScheduleInterview
